// action - state management
import { REGISTER, LOGIN, LOGOUT, DISABLED, NOTVERIFIED } from './actions';

// initial state
export const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  isDisabled: true,
  isVerified: false,
  user: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case NOTVERIFIED: {
      const { user } = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        isInitialized: true,
        isVerified: false,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        isInitialized: true,
        isDisabled: false,
        isVerified: true,
        user
      };
    }
    case DISABLED: {
      const { user } = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        isInitialized: true,
        isDisabled: true,
        isVerified: true,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isAuthenticated: false,
        isDisabled: false,
        isVerified: false,
        user: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
